import { createReducer, on } from '@ngrx/store';

import { resetUser, setUser, setUserSettings, setUserSubstitutees, setUserTheme } from './user.actions';
import { UserSettings } from 'src/app/shared/models/user-settings.model';

export const userFeatureKey = 'user';

export interface UserState {
  initialized: boolean;
  user: string;
  substitutees: string[];
  theme: string;
  settings: UserSettings;
}

export const userInitialState: UserState = {
  initialized: false,
  user: null,
  substitutees: null,
  theme: null,
  settings: null,
};

export const userReducer = createReducer(
  userInitialState,

  on(setUser, (state, {user}) => ({...state, initialized: true, user})),
  on(setUserSubstitutees, (state, {substitutees}) => ({...state, initialized: true, substitutees})),
  on(setUserTheme, (state, {theme}) => ({...state, theme })),
  on(setUserSettings, (state, {settings}) => ({...state, settings })),
  on(resetUser, state => ({...state, initialized: true, user: null, substitutees: null}))
);
